/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Anticipationmax1Inputs */



/**
* | output |
* | --- |
* | "Maximum anticipation" |
*
* @param {Br_History_Key_Anticipationmax1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_anticipationmax1 = /** @type {((inputs?: Br_History_Key_Anticipationmax1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Anticipationmax1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Maximum anticipation")
	return /** @type {LocalizedString} */ ("Anticipation maximale")
});
export { br_history_key_anticipationmax1 as "br_history_key_anticipationMax" }